<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="toca"><a id="page_vii"></a><a href="#/xhtml/07_Acknowledgments"><i>Acknowledgments</i></a></p>
<p class="toca"><a href="#/xhtml/08_Introduction"><i>Introduction</i></a></p>
<p class="toct"><a href="#/xhtml/10_Chapter01"><b>1</b> Migration and a New Start in the 1920s</a></p>
<p class="toc"><a href="#/xhtml/11_Chapter02"><b>2</b> Coping with Hard Times in the 1930s</a></p>
<p class="toc"><span href="#/xhtml/12_Chapter03" title="Link target outside of Sample"><b>3</b> The Slow Pull Upward, Late 1930s</span></p>
<p class="toc"><span href="#/xhtml/13_Chapter04" title="Link target outside of Sample"><b>4</b> Into the Storm, 1939–1941</span></p>
<p class="toc"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample"><b>5</b> Duty Calls Every Citizen, 1942</span></p>
<p class="toc"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample"><b>6</b> Bearer of Bad News, 1942</span></p>
<p class="toc"><span href="#/xhtml/16_Chapter07" title="Link target outside of Sample"><b>7</b> Urgent Preparation, 1943</span></p>
<p class="toc"><span href="#/xhtml/17_Chapter08" title="Link target outside of Sample"><b>8</b> Together, and Alone, 1943</span></p>
<p class="toc"><span href="#/xhtml/18_Chapter09" title="Link target outside of Sample"><b>9</b> Despair and Bitter Hope, 1944</span></p>
<p class="toc"><span href="#/xhtml/19_Chapter10" title="Link target outside of Sample"><b>10</b> Invasion, 1944</span></p>
<p class="toc"><span href="#/xhtml/20_Chapter11" title="Link target outside of Sample"><b>11</b> Will It Never End? 1945</span></p>
<p class="toc"><span href="#/xhtml/21_Chapter12" title="Link target outside of Sample"><b>12</b> We’ll Meet Again, 1945</span></p>
<p class="toc"><span href="#/xhtml/22_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="tocat"><span href="#/xhtml/23_Bm01" title="Link target outside of Sample"><i>Sources</i></span></p>
<p class="toca"><span href="#/xhtml/24_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?99572b0c